<template>
  <div
    class="dropdown-options flex pl-12 pr-3 pb-8 pt-7"
    :class="isDropdown ? 'dropdown' : 'no-dropdown'"
  >
    <div v-if="categories.results.length > 0" class="w-52 flex flex-col">
      <div
        v-for="category in categories.results"
        :key="category.id"
        class="option"
      >
        <h4 v-if="category.visible" @click="emit('closeMenu', true)">
          <w-navigation
            :params="{
              name: categoryPageName(category.slug)
            }"
            :full="false"
          >
            <template #link>
              {{ category.name }}
            </template>
          </w-navigation>
        </h4>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useGeneral } from "@/composables/useGeneral";
import { useMag } from "@/composables/useMag";

import WNavigation from "@/components/general/ui/WNavigation";

const { categories } = useMag();

defineProps({
  typeSection: {
    type: String,
    required: true
  },
  isDropdown: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(["closeMenu"]);
const categoryPageName = categoryName => {
  switch (categoryName) {
    case "trending":
      return "TrendingPage";
    case "curiosidades":
      return "CuriositiesPage";
    case "generos":
      return "GenresPage";
    case "festivales":
      return "FestivalsPage";
    case "playlists":
      return "PlaylistsPage";
    case "internacional":
      return "InternationalPage";
    case "wegowlive":
      return "WegowLivePage";
  }
};
</script>

<style scoped lang="scss">
.dropdown-options {
  background-color: $backgroundBlack;
  &.no-dropdown {
    margin-top: 33px;
    position: absolute;
  }
  &.dropdown {
    flex-direction: column;
    padding: 0px;
    padding-left: 24px;
    & > div {
      width: 100%;
      .option {
        padding-left: 0px;
        padding-right: 0px;
      }
      .show-more {
        text-align: left;
        display: block;
        margin-bottom: 20px;
      }
    }
  }
  h4 {
    font-weight: 700;
    font-size: 15px;
    line-height: 40px;
  }
  a {
    margin: 0px;
  }
  .option {
    color: $textSubtitle;
    line-height: 30px;
  }
  .show-more {
    color: $topaz;
    line-height: 30px;
    text-decoration: underline;
  }
}
</style>
